import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const ForgeFooterModule = withAsync({
	loader: lazyForPaint(
		() => import(/* webpackChunkName: "portal-forge-ui-footer" */ './portal-footer'),
	),
	LoadingSkeleton: () => null,
});
